import React from 'react'

const MadeByBRB = () => {
    return (
        <div>
            <div className='flex items-center justify-end w-full'>
                <div
                    className='font-color-5 text-xs flex justify-end items-center mr-8 bg-color-1 w-fit pr-2 py-2 rounded-full'>
                    <a href="https://it-brb.de" target="_blank" rel="noopener noreferrer">
                        <img
                            src="https://cdn.prod.website-files.com/66028bb96b7aa0fd3ff05dc4/6602ae8579ec850c12d8bcff_logo.webp"
                            alt="IT-BRB Logo"
                            className="w-12 h-auto ml-2"
                        />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default MadeByBRB